import { writable } from "svelte/store";

export const domainBlockVisibleStore = writable(false);
